
class HXFormFieldSignature extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            if (!this.getOptional() && this.getValue().length === 0) {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());

                document.getElementById('js_hxformfield_signature_' + this.inputName).classList.add("hxformfield_signature_focus");
                setTimeout(function(inputName){
                    document.getElementById('js_hxformfield_signature_' + inputName).classList.remove("hxformfield_signature_focus");
                },1500,this.inputName);
                this.validationPassed = false;
            }

            if (alertResult===true) super._validateFieldAlert();

        }

        return this.validationPassed;
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,"signature");
    }

    /**
     * liefert "data:image/png;base64,iVBORw0KGgoAAAANS....
     * @returns {string}
     */
    getValue() {
        return this.getDataStorageJQeryObj().val(); //liefert "data:image/png;base64,iVBORw0KGgoAAAANS...."
    }

    /**
     * Fuer das Feld kann derzeit kein Value per JS gesezt werden
     */
    setValue() {
        //Feld hat keinen input value
        //Todo: implementieren? vgl. setValue()
    }

    /**
     * @returns {canvas}
     */
    getCanvasJQObj(){
        return $('#js_hxformfield_signature_canvas_'+this.inputName);
    }

    /**
     * @private
     * @returns {JQuery-Object}
     */
    getDataStorageJQeryObj(){
        return $('[name=hxformfield_signature_hidden_data_'+this.inputName+']');
    }

    /**
     * @private
     * @param signaturePad
     * @param canvas
     */
    resizeCanvas(signaturePad,canvas) {
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);

        canvas.get(0).width = canvas.get(0).offsetWidth * ratio;
        canvas.get(0).height = canvas.get(0).offsetHeight * ratio;
        canvas.get(0).getContext('2d').scale(ratio, ratio);
        signaturePad.clear();
    }

    clear() {
        if (this.getEditable()) {
            var canvas = this.getCanvasJQObj();
            var signaturPad = new SignaturePad(canvas[0], {backgroundColor: 'rgb(255, 255, 255)' });
            var dataStorageJQObj = this.getDataStorageJQeryObj();
            dataStorageJQObj.val("");
            signaturPad.clear();
            this.getFieldObj().dispatchEvent(new Event("change"));
        }
    }

    /**
     * Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true) {
            var canvas = this.getCanvasJQObj();
            var signaturPad = new SignaturePad(canvas[0], {backgroundColor: 'rgb(255, 255, 255)'});
            var dataStorageJQObj = this.getDataStorageJQeryObj();

            signaturPad.addEventListener('endStroke', () => {
                dataStorageJQObj.val(signaturPad.toDataURL())
            }, {once: false});
            this.resizeCanvas(signaturPad, canvas);

            var startSig = dataStorageJQObj.val()
            var ratio = canvas.naturalWidth / canvas.naturalHeight;
            var width = canvas.width;
            var height = width / ratio;
            if (startSig !== '') signaturPad.fromDataURL(startSig)

            if (this.getEditable()) {
                $(canvas).on("click",(event)=>{this.getFieldObj().dispatchEvent(new Event("change"));});

                $('#js_hxformfield_signature_delete_img_' + this.inputName).on('click', (event) => {
                    this.clear();
                });
            } else {
                signaturPad.off()
            }
        }
    }

}